import { hm5LimitedReleasesListConstants } from "../_redux-constants";

export function hm5LimitedReleasesListReducer(
  state = {
    hm5LimitedReleasesListLoading: false,
    hm5LimitedReleasesListData: null,
    hm5LimitedReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case hm5LimitedReleasesListConstants.HM5_LIMITED_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        hm5LimitedReleasesListLoading: true,
        hm5LimitedReleasesListData: null,
        hm5LimitedReleasesListError: null,
      });
    case hm5LimitedReleasesListConstants.HM5_LIMITED_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        hm5LimitedReleasesListLoading: false,
        hm5LimitedReleasesListData: action.data,
      });
    case hm5LimitedReleasesListConstants.HM5_LIMITED_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        hm5LimitedReleasesListLoading: false,
        hm5LimitedReleasesListData: null,
        hm5LimitedReleasesListError: action.error,
      });
    default:
      return state;
  }
}
